export enum PermissionAction {
  READ = "read",
  WRITE = "write",
  UPDATE = "update",
  DELETE = "delete",
  MANAGE = "manage",
}
